import { formatCurrencyAmount, numberWithCommas } from '@eapproval/offer-shared'

import { isNullish } from './helper'

export { formatCurrencyAmount, numberWithCommas }

export const acronyms = ['RFQ', 'DLP', 'IPR', 'CIC', 'EPD', 'LPL', 'LoA', 'GCBAU', 'GCFS', 'LD', 'SISIC', 'CPM']

export const nonTitleWords = ['of', 'for', 'in']
export const convertToWords = (str) => {
  if (typeof str !== 'string') return ''
}

export const camelToWords = (str) => {
  if (typeof str !== 'string') {
    return ''
  }

  // Split camelCase and numbers
  let words = str
    .replace(/([a-z])([A-Z0-9])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .split(' ')

  // Further split words if they start with an acronym
  const expandedWords = []
  for (let word of words) {
    let matched = false
    for (const acr of acronyms.filter(Boolean)) {
      if (word.toUpperCase().startsWith(acr.toUpperCase()) && acr.length > 1) {
        expandedWords.push(acr)
        const rest = word.slice(acr.length)
        if (rest) expandedWords.push(rest)
        matched = true
        break
      }
    }
    if (!matched) expandedWords.push(word)
  }

  // Title-case non-acronyms, preserve acronyms
  return expandedWords
    .map((word) => {
      const found = acronyms.find((acr) => acr && word.toUpperCase() === acr.toUpperCase())
      // const is
      if (found) {
        return found
      }

      // if()
      return found ? found : word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(' ')
}

export const roundNumber = (number, digit = 2) =>
  Math.round((parseFloat(number) + Number.EPSILON) * 10 ** digit) / 10 ** digit

export const round = (value, decimals) => Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`)

export const capitalizeFirstLetter = (string) => {
  if (typeof string !== 'string') {
    return string
  }

  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const isDate = (date) => Object.prototype.toString.call(date) === '[object Date]'

export const isEmpty = (obj) => [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length

export const isNumeric = (str) => {
  if (typeof str === 'number') {
    return true
  }

  if (typeof str !== 'string') return false // we only process strings!

  console.log('is string')
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ) // ...and ensure strings of whitespace fail
}

export const isString = (str) => typeof str === 'string' || str instanceof String

export const stringToNumber = (str) => {
  if (typeof str === 'number') {
    return str
  }

  if (typeof str !== 'string') {
    return 0
  }

  return Number(str.replace(/[,/#!$%^&*;:{}=\-_`~()]/g, ''))
}

export const getNumberOrdinal = (number) => {
  if (typeof number !== 'number') {
    return ''
  }

  let ord = 'th'

  if (number % 10 == 1 && number % 100 != 11) {
    ord = 'st'
  } else if (number % 10 == 2 && number % 100 != 12) {
    ord = 'nd'
  } else if (number % 10 == 3 && number % 100 != 13) {
    ord = 'rd'
  }

  return number + ord
}

export const isValidNonEmptyString = (str) => {
  if (isNullish(str) || typeof str !== 'string') {
    return false
  }

  return str !== ''
}

export const getDuplicateName = (str) => {
  const match = str.match(/\((\d+)\)$/)

  if (match) {
    const number = parseInt(match[1], 10) + 1
    return str.replace(/\(\d+\)$/, `(${number})`)
  } else {
    return `${str} (1)`
  }
}

export const paddingZeroString = (number, size = 4) => {
  let string = number.toString()
  while (string.length < size) {
    string = '0' + string
  }
  return string
}

export const getYesNoValue = (value) => {
  if (typeof value === 'boolean') {
    return value ? 'yes' : 'no'
  }

  if (typeof value === 'string') {
    return value.trim().toLowerCase() === 'yes' ? 'yes' : 'no'
  }

  return 'no'
}

export const formatBaseQuotationNumber = (baseQuotationNumber) => {
  if (!baseQuotationNumber) {
    return ''
  }

  const parts = String(baseQuotationNumber).split('-')

  if (parts.length >= 3) {
    return `${parts[0]}-${parts[1]}`
  }

  return String(baseQuotationNumber)
}

export const numberToColumnKey = (index) => {
  let columnKey = ''
  while (index > 0) {
    let remainder = (index - 1) % 26
    columnKey = String.fromCharCode(65 + remainder) + columnKey
    index = Math.floor((index - 1) / 26)
  }
  return columnKey
}

export const toNumber = (value) => {
  const num = parseFloat(value)
  return Number.isFinite(num) ? num : 0
}
